import React from 'react';
import './Breadcrum.css';
import arrow_icon from '../Assets/breadcrum_arrow.png';
import { useNavigate } from 'react-router-dom';

const Breadcrums = (props) => {
  const navigate = useNavigate();
  const handleCategoryClick = (category) => {
    navigate('/shop', { state: { category: category } });
  };
  const { product } = props;

  return (
    <div className='font-montserrat font-medium text-[#551E19] flex flex-wrap items-center gap-2 mt-10 md:mt-20  px-[3%] md:px-[5%] lg:px-[10%]'>
      <button onClick={() => navigate('/')} className="text-xs sm:text-sm">HOME</button>
      <img src={arrow_icon} alt='' className="w-3 h-3 sm:w-4 sm:h-4" />
      <button onClick={() => navigate('/shop')} className="text-xs sm:text-sm">SHOP</button>
      <img src={arrow_icon} alt='' className="w-3 h-3 sm:w-4 sm:h-4" />
      <button className="text-xs sm:text-sm uppercase" onClick={() => handleCategoryClick(product.category)}>{product.category}</button>
      <img src={arrow_icon} alt='' className="w-3 h-3 sm:w-4 sm:h-4" />
      <span className="text-xs sm:text-sm uppercase">{product.name}</span>
    </div>
  );
}

export default Breadcrums;